import ajax from '../utils/axios'

// 登录
export const PostLogin = (params) => ajax.post('/index/login/login', params)

// 检测登录状态
export const CheckLogin = (params) => ajax.get('/index/login/check', params)

// 修改密码
export const PostChangePwd = (params) => ajax.post('/index/user/change_pwd', params)

// 登出
export const GetLogout = (params) => ajax.get('/index/login/logout', params)

// 新增问题件
export const PostAddOrder = (params) => ajax.post('/index/order/add', params, {
  headers: { 'Content-Type': 'multipart/form-data' }
})

// 导入问题件
export const PostImportOrder = (params) => ajax.post('/index/order/import', params, {
  headers: { 'Content-Type': 'multipart/form-data' }
})
